// extracted by mini-css-extract-plugin
export var accordionBody = "style-mod--accordion-body--2d87a";
export var accordionCard = "style-mod--accordion-card--c960c";
export var accordionIcon = "style-mod--accordion-icon--f2adc";
export var accordionIconOpen = "style-mod--accordion-icon-open--2d3f2";
export var accordionSubtitle = "style-mod--accordion-subtitle--fed7f";
export var accordionTitle = "style-mod--accordion-title--63932";
export var cardHeader = "style-mod--card-header--f2368";
export var clipStar = "style-mod--clip-star--af6fd";
export var frContent = "style-mod--fr-content--9d92f";
export var freeReturns = "style-mod--free-returns--199ad";
export var hImg = "style-mod--h-img--1714a";
export var hSubtitle = "style-mod--h-subtitle--72da3";
export var hTitle = "style-mod--h-title--3df0d";
export var highlight = "style-mod--highlight--4e47f";
export var highlightContent = "style-mod--highlight-content--21bab";
export var imgContent = "style-mod--img-content--c0cb0";
export var pdpService = "style-mod--pdp-service--165fd";
export var ratingText = "style-mod--rating-text--868db";
export var sBtn = "style-mod--s-btn--46e9c";
export var sDescription = "style-mod--s-description--dc6b3";
export var sPrice = "style-mod--s-price--7251a";
export var sTitle = "style-mod--s-title--11818";
export var scFigure = "style-mod--sc-figure--34f70";
export var scImg = "style-mod--sc-img--a15a6";
export var serviceContent = "style-mod--service-content--b64ae";
export var serviceContentText = "style-mod--service-content-text--3be51";
export var serviceDescription = "style-mod--service-description--98e53";
export var serviceHighlight = "style-mod--service-highlight--03cfe";
export var serviceTwoColumn = "style-mod--service-two-column--e2a08";
export var shTitle = "style-mod--sh-title--6850b";
export var shippingEta = "style-mod--shipping-eta--affd7";
export var tcBtn = "style-mod--tc-btn--3e088";
export var tcImg = "style-mod--tc-img--ea1b1";
export var tcSubtitle = "style-mod--tc-subtitle--25d5c";
export var tcTitle = "style-mod--tc-title--707b5";
export var textContent = "style-mod--text-content--20ba8";
export var tooltipInfo = "style-mod--tooltip-info--bee7b";
export var yStars = "style-mod--y-stars--12513";